import { PublicSeccionResponse } from '@ahora-patagonia/contracts';
import type { ApiClient } from '../../../shared/http/ApiClient.js';
import { fixtureSeccion, fixturesActivos } from '../../../shared/fixtures/publicFixtures.js';
import type { SeccionData, SeccionKind } from '../entities/SeccionData.js';

/**
 * Acceso a `/ultima-hora` y `/mas-leidas`, paginadas de a 12 ("Ver más").
 *
 * Un solo repositorio para las dos: el contrato de la respuesta es el mismo y lo único que cambia es
 * el path. Dos clases idénticas serían dos lugares donde arreglar el mismo bug.
 *
 * **No hay 404 posible** —al contrario de una categoría—: las dos páginas existen siempre para
 * cualquier medio, aunque estén vacías. Una sección sin nada que mostrar tiene estado vacío, no error.
 */
export class SeccionRepository {
  constructor(private readonly api: ApiClient) {}

  async porPagina(kind: SeccionKind, page = 1): Promise<SeccionData> {
    const fixtures = fixturesActivos();
    if (fixtures) return fixtureSeccion(kind, fixtures);

    const data = await this.api.get<unknown>(`/public/${kind}?page=${page}`);
    return PublicSeccionResponse.parse(data);
  }
}
